import { cn } from '@/lib/utils';

interface TeamFitBadgeProps {
  score: string | null | undefined;
  className?: string;
}

export function TeamFitBadge({ score, className }: TeamFitBadgeProps) {
  if (!score) return <span className="text-xs text-muted-foreground">—</span>;
  const num = parseFloat(score);
  if (isNaN(num)) return <span className="text-xs text-muted-foreground">—</span>;

  const color =
    num >= 80
      ? 'text-green-600 dark:text-green-400'
      : num >= 50
        ? 'text-yellow-600 dark:text-yellow-400'
        : 'text-red-600 dark:text-red-400';

  return <span className={cn('text-sm font-semibold', color, className)}>{num.toFixed(0)}</span>;
}
